export const TICKET_CATEGORIES = [
    "courier",
    "company",
    "onboarding_company",
    "onboarding_agency",
    "other"
];

// İletişim formu ("Diğer") talepleri dinamik yetki politikasıyla görülür (admin rolleri hariç)
export const TICKET_PERMISSION_KEYS = {
    viewOther: "viewOtherTickets"
};

// Sekmesi kategoriye özel görme yetkisi isteyen kategoriler ve yetkiyi hesaplayan meStore.checkRole anahtarları
export const TICKET_CATEGORY_ACCESS_ROLES = {
    onboarding_agency: "agencyApplicationView",
    other: "otherTicketView"
};

// Sahibi web sitesi başvurusu olan kategoriler; detay sayfaları /applications altındadır
export const TICKET_ONBOARDING_CATEGORY_TYPES = {
    onboarding_company: "company",
    onboarding_agency: "agency"
};

export const TICKET_PRIORITIES = ["low", "medium", "high"];

export const TICKET_PRIORITY_COLORS = {
    low: "default",
    medium: "blue",
    high: "gold"
};

export const TICKET_OPTIONS_GROUP_NAME = "ticket";

export const TICKET_ROLE_OPTIONS_KEY = "ticketRoleCode";

export const TICKET_TOPIC_OPTIONS_KEYS = {
    courier: "ticketTopicCourier",
    company: "ticketTopicCompany",
    onboarding_company: "ticketTopicOnboardingCompany",
    onboarding_agency: "ticketTopicOnboardingAgency",
    other: "ticketTopicOther"
};

export const TICKET_STATUSES = ["open", "in_review", "closed", "cancelled"];

export const TICKET_STATUS_COLORS = {
    open: {tag: "blue", background: "#e6f4ff"},
    in_review: {tag: "orange", background: "#fff7e6"},
    closed: {tag: "green", background: "#f6ffed"},
    cancelled: {tag: "#ff4243", background: "#ffecec"}
};

export const TICKET_SCOPES = {
    mine: "mine",
    assignedToMe: "assignedToMe",
    claimable: "claimable",
    owner: "owner",
    customer: "customer"
};

export const TICKET_LIST_STATES = {open: "open", closed: "closed"};

export const TICKET_STATUSES_BY_STATE = {
    open: ["open", "in_review"],
    closed: ["closed", "cancelled"]
};

export const TICKET_MAX_PHOTO_COUNT = 3;

// Backoffice dışı taraflar (işletme paneli) için talep sistemi geçici olarak kapalıdır; true iken müşteri menüsünde
// Talep Yönetimi gösterilmez ve kurye/işletme talebinin "sahibine görünsün" switch'i kilitlenir. Yeniden açmak için false yapılır.
export const IS_TICKET_EXTERNAL_ACCESS_BLOCKED = true;

export const TICKET_MAX_OPEN_COUNT = 3;

export const TICKET_PHOTO_ACCEPT = ".png,.jpg,.jpeg,.heic";

export const TICKET_MAX_DESCRIPTION_LENGTH = 2000;

export const TICKET_MAX_NOTE_LENGTH = 2000;

// Talep ekranlarına erişebilen panel rolleri (müşteri paneli kullanıcısı cUser hariç)
export const TICKET_BACKOFFICE_ROLES = [
    "admin",
    "superadmin",
    "software",
    "finance",
    "hr",
    "hrEmployment",
    "equipmentManager",
    "ik",
    "fieldManager",
    "operationSupport",
    "sOperation",
    "sChef",
    "data",
    "operationImproving",
    "marketing",
    "seller",
    "bm",
    "sy",
    "agency",
    "agencyIk",
    "sales"
];

// Talep türünde otomatik atama departmanı olarak sunulmayan roller (yalnızca elle atanır)
export const TICKET_NON_AUTO_ASSIGN_ROLES = ["subAgency"];

// Talep sisteminin dışında tutulan roller (backend'deki excludedRoles ile aynı); departman listelerinde gösterilmez
export const TICKET_EXCLUDED_ROLES = ["oUser"];

export const TICKET_PAIRED_ROLES = {
    bm: ["agency"],
    sy: ["agency"],
    agency: ["bm", "sy"],
    ik: ["agencyIk"],
    agencyIk: ["ik"]
};

export const TICKET_ADMIN_ROLES = ["admin", "superadmin", "software"];

// Kullanıcılar sayfasını ve Kullanıcı Detay'ı salt okunur görebilen roller (yönetim işlemleri kapalı)
export const USER_TICKET_VIEWER_ROLES = [
    "bm",
    "sy",
    "equipmentManager",
    "finance",
    "hrEmployment",
    "ik",
    "operationSupport"
];
